import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

/**
 * The frame around an ops section.
 *
 * These started life as modals. A modal is the wrong shape for work someone
 * does all day — it hides the rest of the application, can't be linked to, and
 * turns "check the other list" into close, click, wait. Given a route they now
 * render as an ordinary page; the dialog form is kept only for the places that
 * genuinely are a brief interruption.
 */
export default function AdminPanel({ inline = false, open = true, onClose, title, subtitle, testId, children }) {
  if (inline) {
    return (
      <section className="ops-panel" data-testid={testId}>
        {(title || subtitle) && (
          <header className="ops-panel__head">
            <div>
              <h1>{title}</h1>
              {subtitle && <p>{subtitle}</p>}
            </div>
          </header>
        )}
        {children}
      </section>
    );
  }

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose?.()}>
      <DialogContent className="admin-package-dialog" data-testid={testId}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
}
